//components
import { Container } from '@/components/Grid/Container';

import {
  SectionWrapper,
  Title,
  ListContainer,
  PhotoWrapper,
  Picture,
  Name,
  Text,
  Link,
} from './Leadership.styles';

const folder = `/images/leadership/portraits/`;

const leadership = [
  {
    name: 'Ricardo Salgado',
    title: 'Executive Chairman & Co-founder',
    picture: 'ricardo-salgado@2x.jpg',
    link: 'https://www.linkedin.com/in/ricardosalgado1/',
  },
  {
    name: 'Felipe Capella',
    title: 'CEO & Co-founder',
    picture: 'felipe-capella@2x.jpg',
    link: 'https://www.linkedin.com/in/felipecapella/',
  },
  {
    name: 'Marcello Mastioni',
    title: 'Chief Operating Officer',
    picture: 'marcello-mastioni@2x.jpg',
    link: 'https://www.linkedin.com/in/mastioni/',
  },
  {
    name: 'Tish Whitcraft',
    title: 'Chief Customer Officer',
    picture: 'tish-whitcraft@2x.jpg',
    link: 'https://www.linkedin.com/in/tishwhitcraft/',
  },
  {
    name: 'Amir Mirza',
    title: 'Chief Financial Officer',
    picture: 'amir-mirza@2x.jpg',
    link: 'https://www.linkedin.com/in/amir-mirza/',
  },
  {
    name: 'Alain Avakian',
    title: 'Chief Technology Officer',
    picture: 'alain-avakian@2x.jpg',
    link: 'https://www.linkedin.com/in/alainavakian/',
  },
];

export const Leadership = () => (
  <SectionWrapper>
    <Container>
      <Title>Meet our leadership team</Title>
    </Container>

    <Container>
      <ListContainer>
        {leadership.map((item, key) => {
          const index = `board-${key}`;
          return (
            <PhotoWrapper key={index}>
              <Picture
                src={`${folder}${item.picture}`}
                alt={`Headshot photo of ${item.name}`}
              />
              <Name>{item.name}</Name>
              <Text>{item.title}</Text>
              <Link
                as="a"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </Link>
            </PhotoWrapper>
          );
        })}
      </ListContainer>
    </Container>
  </SectionWrapper>
);
